import React from "react";
import "./AwardsSection.css";

const awards = [
  {
    img: "https://static.wixstatic.com/media/6870b3_fbbd071a5f6a4539989b8eea467c58af~mv2.jpg",
    title: "Vidhyasree Rathna Award",
    desc: (
      <>
        Received from <br />
        Hon'ble Chief Minister <br />
        <b>Sri. Jagadeesh Shettar</b>
      </>
    ),
  },
  {
    img: "https://static.wixstatic.com/media/6870b3_e83effd80fa44cc3acf694065ddf88f7~mv2.png",
    title: "Honour to Host",
    desc: (
      <>
        Sri. Suresh Kumar, MLA <br />
        Education Minister, Govt of Karnataka
      </>
    ),
  },
  {
    img: "https://static.wixstatic.com/media/6870b3_9a3ed5dc930f482d881fdc0bc5cb6ab7~mv2.jpg",
    title: "Best Educationist Award",
    desc: (
      <>
        Received from Bharatha Rathna <br />
        & Former Union Minister <br />
        <b>Sri. Gulzarilal Nanda</b>
      </>
    ),
  },
  {
    img: "https://static.wixstatic.com/media/6870b3_cd435c203c744219a2a8bc52b84747e9~mv2.jpg",
    title: "Featured on Janashree News",
    desc: "Featured on Women Empowerment Series",
  },
];

const AwardsSection = () => {
  return (
    <section className="awards-section">
      <div className="awards-container">
        <h2 className="awards-title">Awards & Honours</h2>
        <p className="awards-subtitle">
          The Teacher Training journey of NIECCE has grown with many recognitions
          & prestigious awards throughout the years.
        </p>

        <div className="awards-grid">
          {awards.map((item, index) => (
            <div className="award-card" key={index}>
              <img
                src={item.img}
                alt={`${item.title} received by NIECCE`}
                title={`${item.title} received by NIECCE`}
                className="award-img"
              />
              <h3 className="award-heading">{item.title}</h3>
              <p className="award-desc">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="awards-buttons">
          <a href="/courses" className="aw-btn">
            Our Courses
          </a>
          <a href="/contact" className="aw-btn secondary">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
